import { sendEvents } from '@fiverr-private/futile/lib/send/sendEvents';

/**
 * Report BI Event to BigQuery
 * @param  {String}  type event type
 */
export default function reportEvent(type, options) {
    const {
        userId,
        sellerId,
        activeGigsCount
    } = window;

    const baseEventData = {
        group: 'seller_page',
        user: {
            id: userId
        },
        seller: {
            id: sellerId,
            active_gigs_count: activeGigsCount
        }
    };

    sendEvents({
        ...baseEventData,
        ...options,
        type
    });
}

export function getSellerPageGigCardViewGigImpression(options) {
    return {
        group: 'seller_page_gig_card_view_gig_impression',
        type: 'seller_page.show$viewport',
        seller: { id: options.sellerId },
        gig: { id: options.gigId },
        page: {
            component: {name: 'seller_last_gig_viewed_card'},
            element: {
                name: 'seller_last_gig_viewed_gig_button',
                type: 'button',
                text: 'View Gig',
                metadata: 'View Gig',
                visible: true
            }
        }
    };
}

export function getSellerPageGigCardContinueButtonImpression(options) {
    return {
        group: 'seller_page_gig_card_continue_button_impression',
        type: 'seller_page.show$viewport',
        seller: { id: options.sellerId },
        gig: { id: options.gigId },
        page: {
            component: {name: 'seller_last_gig_viewed_card'},
            element: {
                name: ' seller_last_gig_card_continue_button',
                type: 'button',
                text: 'Continue',
                metadata: options.price,
                visible: true
            }
        }
    };
}

export function clickOnContinue(options) {
    return {
        gig: { id: options.gigId},
        page: {
            component: {
                name: 'seller_last_gig_viewed_card'
            },
            element: {
                type: 'button',
                text: 'Continue',
                metadata: options.price,
                name: 'seller_last_gig_card_viewed_component'
            },
            ctx_id: options.pageCtxId
        }
    };
}

export function clickOnViewGig(options) {
    return {
        gig: { id: options.gigId},
        page: {
            component: {
                name: 'seller_last_gig_viewed_card'
            },
            element: {
                type: 'button',
                text: 'View Gig',
                metadata: 'View Gig',
                name: 'seller_last_gig_card_continue_button'
            },
            ctx_id: options.pageCtxId
        }
    };
}

export function getWideGigBiData(options) {
    return {
        group: 'seller_page_gig_card_viewed_impression',
        type: 'seller_page.show$viewport',
        seller: { id: options.sellerId },
        gig: { id: options.gigId },
        page: {
            component: {name: 'seller_last_gig_viewed_card'},
            element: {
                name: 'seller_last_gig_card_viewed_component',
                text: options.text,
                visible: options.visible
            }
        }
    };
}


// WEBPACK FOOTER //
// ./src/common/lib/reportEvent.js